export const hasContent = value => {
  return value !== undefined && value !== null && value !== "";
};
